import { render, staticRenderFns } from "./GiftAutocomplete.vue?vue&type=template&id=b2542e1c&"
import script from "./GiftAutocomplete.vue?vue&type=script&lang=js&"
export * from "./GiftAutocomplete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports